import { Component, Input } from "@angular/core";
import { Formrequest } from "../model/formrequest";
import { FormrequestService } from "../service/formrequest.service";
import { DatePipe } from "@angular/common";
import { Multilingua } from "../model/multilingua";
import { MultilinguaService } from "../service/multilingua.service";
import { Location } from "@angular/common";
import { MenuService } from "../service/menu.service";

@Component({
  selector: "app-formrequest",
  templateUrl: "./formrequest.component.html",
})
export class FormrequestComponent {
  public element: Formrequest = new Formrequest();
  public message;
  public privacy;
  public captcha = "";
  public lingua: string;
  @Input() language: string;

  constructor(
    private formrequestService: FormrequestService,
    private multilingueService: MultilinguaService,
    private location: Location,
    private menuService: MenuService,
    public datepipe: DatePipe
  ) {
    menuService.lang$.subscribe((lang) => this.onItemLang(lang));
  }

  onItemLang(lang: string) {
    this.lingua = lang;
  }

  send() {
    this.element.data = this.datepipe.transform(new Date(), "yyyy-MM-dd hh:mm");
    this.element.url = location.href;
    this.formrequestService.save(this.element).subscribe((email) => {
      if (email != null) {
        this.message = "Grazie per averci scritto!";
        this.element = new Formrequest();
      }
    });
  }

  public resolved(captchaResponse: string) {
    console.log(`Resolved captcha with response: ${captchaResponse}`);
  }
}
